import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import { Link } from 'react-router-dom';
import '../csscomponent/Career.css';
import { getCmsCareerJobs, getCmsSettings } from '../lib/sqlAuth';
import { subscribeCmsUpdates } from '../lib/cmsSync';

function Career() {
  const [careerAnim, setCareerAnim] = useState(null);
  const [openings, setOpenings] = useState([]);
  const [content, setContent] = useState({
    eyebrow: 'Careers',
    title: 'Build products that matter with a high-ownership team.',
    description: 'We move fast, stay practical, and ship real value for clients and users.',
    steps: ['Apply with your portfolio', 'Intro + technical discussion', 'Paid task / case round', 'Offer and onboarding'],
  });

  useEffect(() => {
    let mounted = true;
    import('../jobhunting.json').then((mod) => {
      if (mounted) setCareerAnim(mod.default);
    });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const [jobsRes, settingsRes] = await Promise.all([
          getCmsCareerJobs(),
          getCmsSettings({ keys: ['career_intro'] }),
        ]);
        if (!mounted) return;
        setOpenings(Array.isArray(jobsRes?.items) ? jobsRes.items.map((job) => ({
          title: job.title,
          type: job.employment_type,
          location: job.location,
          detail: job.description_html,
        })) : []);
        const intro = settingsRes?.settings?.career_intro || {};
        setContent((prev) => ({ ...prev, ...intro }));
      } catch (_) {}
    };
    load();
    const unsubscribe = subscribeCmsUpdates((payload) => {
      if (!payload?.scope || ['site', 'jobs'].includes(payload.scope)) {
        load();
      }
    });
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  return (
    <section className="career-page">
      <motion.div
        className="career-intro"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div>
          <p>Careers</p>
          <h1>{content.title}</h1>
          <span>{content.description}</span>
        </div>
        <div className="career-lottie-wrap">
          {careerAnim ? <Lottie animationData={careerAnim} loop className="career-lottie" /> : null}
        </div>
      </motion.div>

      <div className="career-grid">
        {openings.map((role, index) => (
          <motion.article
            key={role.title}
            className="career-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <h3>{role.title}</h3>
            <div className="career-meta">
              <span>{role.type}</span>
              <span>{role.location}</span>
            </div>
            <p>{role.detail}</p>
            <Link to={`/career/job-apply?role=${encodeURIComponent(role.title)}`}>Apply Now</Link>
          </motion.article>
        ))}
      </div>

      <div className="career-flow">
        <h2>Our Hiring Process</h2>
        <div className="flow-list">
          {(Array.isArray(content.steps) ? content.steps : []).map((step, index) => (
            <div key={step} className="flow-item">
              <strong>{index + 1}</strong>
              <span>{step}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Career;
